import { createFileRoute } from "@tanstack/react-router";
import { Footer, Header, PAGE_CONTAINER } from "@/components/site";
import { NieuwsKaarten } from "@/components/nieuws";
import { nieuwsQuery } from "@/lib/nieuws.functions";
import { SITE } from "@/lib/seo-data";
import { useTaal } from "@/lib/taal";

export const Route = createFileRoute("/nieuws/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(nieuwsQuery()),
  head: () => ({ meta: [
    { title: "Nieuws en advies over elektra | offerto" },
    { name: "description", content: "Lees praktisch advies over groepenkasten, Perilex, laadpalen en elektricienkosten. Vergelijk oplossingen en vind een passende elektricien." },
    { property: "og:title", content: "Nieuws en advies over elektra | offerto" },
    { property: "og:description", content: "Praktische artikelen over elektra, installatiekosten en offertes vergelijken." },
    { property: "og:type", content: "website" }, { property: "og:url", content: `${SITE}/nieuws` }, { name: "twitter:card", content: "summary_large_image" },
  ], links: [{ rel: "canonical", href: `${SITE}/nieuws` }] }),
  component: Nieuws,
});
function Nieuws() {
  const artikelen = Route.useLoaderData();
  const { t } = useTaal();
  return <div className="min-h-screen bg-background"><Header /><main className={`${PAGE_CONTAINER} py-12`}><h1 className="text-3xl font-extrabold">{t("nieuwsTitel")}</h1><NieuwsKaarten artikelen={artikelen} vullers={artikelen.length < 4 ? [
    { datum: "22 SEP 2026", titel: t("nieuws1Titel"), tekst: t("nieuws1Tekst"), lees: t("klusLaadpaal"), to: "/elektricien/laadpaal-installeren" },
    { datum: "22 SEP 2026", titel: t("nieuws2Titel"), tekst: t("nieuws2Tekst"), lees: t("nieuwsLees"), to: "/diensten" },
    { datum: "22 SEP 2026", titel: t("nieuws3Titel"), tekst: t("nieuws3Tekst"), lees: t("nieuwsLees"), to: "/diensten" },
    { datum: "22 SEP 2026", titel: t("nieuws4Titel"), tekst: t("nieuws4Tekst"), lees: t("nieuwsLees"), to: "/diensten" },
  ].slice(0, 4 - artikelen.length) : []} /></main><Footer /></div>;
}